module.exports = __webpack_public_path__ + "static/2front-positions-3-b237ccebcc81032c25416a2c39b3e6fc.png";